<template>
    <div class="insight template4">
        <div
            class="header"
            v-sticky="isMobileSize ? { class: 'fixed' } : false"
        >
            <i
                @click="hideInSight"
                class="rotate iconfont icon-chevron_right"
            ></i>
            <span @click="hideInSight" class="listing_quantity">{{
                $t('md-search-result.listings', { searchCount })
            }}</span>
        </div>
        <div class="guide">
            <div class="guild_content" v-if="activeCounts > 0">
                {{
                    $t('md-search-result.hasActiveListings', {
                        locationName: lastLevelLocation.name,
                        activeCounts: $t('md-search-result.activeListing', { count: activeCounts }),
                        price: currencySymbol + formatNumber(averageData.price),
                        bed: getAverageDataLabel(averageData.bedrooms, 'beds'),
                        bath: getAverageDataLabel(averageData.baths, 'baths'),
                        sqft: getAverageDataLabel(averageData.sqft, 'sqft')
                    })
                }}
            </div>
        </div>
        <div class="market-report-insight">
            <MarketReport
                ref="marketReport"
                :title="marketReportTitle"
                type="insight"
            />
        </div>
        <div class="market-trends">
            <MarketTrends
                type="insight"
                ref="marketTrends"
                :extraTitle="marketTrendsExtraTitle"
                @marketTrendsMounted="fetchMarketTrendsData"
            />
        </div>
        <div class="rencent-sold-wrap" v-if="recentSoldCount > 0">
            <RecentSold
                :title="recentSoldTitle"
                :listings="recentSoldListings"
                :snapshotLink="snapshotLink"
                :count="recentSoldCount"
            />
        </div>
        <div class="explore-listing">
            <ExploreListings
                theme="template4-listing-market-insight"
                :breadCrumbs="breadCrumbs"
                :keywords="keywords"
                :averageData="averageStoreData"
            />
        </div>
        <div class="explore-nbr-wrap">
            <ExploreNbr
                theme="template4-listing-market-insight"
                :breadCrumbs="breadCrumbs"
            />
        </div>
        <div class="quick-search" v-if="quickSearchData">
            <module-layout
                :id="quickSearchData.id"
                :mdData="quickSearchData"
                :inner="true"
                class="inner"
            />
        </div>
        <div class="search-seo-insight" v-if="searchSeoData">
            <module-layout
                :id="searchSeoData.id"
                :mdData="searchSeoData"
                :inMapList="searchSeoData"
                :inner="true"
                :insight="true"
                class="inner"
            />
        </div>
        <div class="footer" v-if="footerData">
            <module-layout
                :id="footerData.id"
                :mdData="footerData"
                :inner="true"
                class="inner"
            />
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import core from '../../insight.js';
import MarketReport from '@/modules/md-snapshot-search/template4/components/market-report';
import RecentSold from './recent-sold';
import ExploreListings from '../../explore-listings';
import ExploreNbr from '../../explore-nbr';
export default {
    mixins: [core],
    components: {
        MarketReport,
        MarketTrends: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "modules/md-market-trends/fashion"*/ '@/modules/md-market-trends/fashion/index.vue'
            )),
        RecentSold,
        ExploreListings,
        ExploreNbr
    }
};
</script>

<style lang="scss">
@import '../../../../theme/media.scss';

@mixin pd {
    padding: 0 20px;
    @include media-800 {
        padding: 0 15px;
    }
}
@mixin title {
    font-size: 18px;
    letter-spacing: normal;
    color: #4a4a60;
    font-family: var(--font-title);
}
@mixin mTitle {
    font-size: 16px;
    letter-spacing: normal;
    color: #4a4a60;
    font-family: var(--font-title);
}
.insight.template4 {
    .fixed {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: var(--level-medium);
    }
    .header {
        @include pd;
        display: flex;
        align-items: center;
        line-height: 22px;
        background-color: #fff;
        .iconfont {
            cursor: pointer;
            &.rotate {
                transform: rotate(180deg);
            }
        }
        .listing_quantity {
            cursor: pointer;
            font-size: 18px;
            padding: {
                left: 5px;
            }
        }
        @include media-min-800 {
            @include title;
            padding: {
                top: 18px;
            }
        }
        @include media-800 {
            @include mTitle;
            padding: {
                top: 11px;
                bottom: 11px;
            }
            border: {
                bottom: 1px solid #f1f2f3;
            }
        }
    }
    .guide {
        @include pd;

        @include media-min-800 {
            margin: {
                top: 22px;
                bottom: 40px;
            }
        }
        @include media-800 {
            margin: {
                top: 20px;
                bottom: 30px;
            }
        }
        .guild_content {
            border-radius: 6px;
            box-shadow: 0 4px 10px 0 rgba(72, 128, 255, 0.2);
            background: url('//cdn.chime.me/image/fs/sitebuild/site-cms/insight-guild-bg.png')
                no-repeat right bottom;
            background-size: 55px 55px;
            background-color: #4c84ff;
            color: #fff;
            line-height: 20px;
            position: relative;
            @include media-min-800 {
                padding: 20px 15px;
            }
            @include media-800 {
                padding: 10px 15px;
                font-size: 14px;
            }
        }
    }
    .market-report-insight {
        @include pd;
        padding-bottom: 35px;
        @include media-min-800 {
            margin-top: -40px;
            .snapshot {
                .title {
                    .pc {
                        padding: {
                            top: 40px;
                        }
                        display: block;
                        /* align-items: center;
                        justify-content: flex-start;
                        flex-wrap: wrap; */
                        .mg-title {
                            @include title;
                            display: block;
                        }
                        .time {
                            margin-top: 15px;
                            display: block;
                        }
                    }
                }
            }

            .snapshot_pc {
                height: auto !important;
                .board_container {
                    .board {
                        justify-content: flex-start;
                        padding: 20px;
                        flex-wrap: wrap;
                        padding-left: 0;

                        .board_card {
                            background-color: #f5f6fa;
                            margin-bottom: 15px;
                            &:first-child {
                                margin-right: 15px;
                            }
                        }
                    }
                }
            }
        }
        @include media-800 {
            .snapshot {
                .title {
                    .mobile {
                        padding: 0;
                        padding-bottom: 20px;
                        display: block;
                        /* display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        flex-wrap: wrap; */
                        .desc {
                            @include mTitle;
                            display: block;
                        }
                        .time {
                            display: block;
                            margin-top: 15px;
                        }
                    }
                }
            }
            .board_container {
                padding-left: 0;
            }
        }
        .no_data {
            padding-top: 40px;
        }
    }
    .market-trends {
        @include pd;
        @include media-800 {
            margin-top: 10px;
        }
        .md-market-trends.fashion {
            margin-bottom: 0 !important;
            .container {
                background: #fff;
                padding-top: 0;
                .mg-container {
                    width: 100%;
                    margin: 0;
                }
                .title_container {
                    flex-wrap: wrap;
                    .mg-title {
                        overflow: hidden;
                        white-space: pre-wrap;
                        @include title;
                    }
                }
                .module_box {
                    padding: 0;
                }
            }
        }
    }
    .rencent-sold-wrap {
        @include pd;
        @include media-min-800 {
            margin-top: -30px;
            .rencent-sold {
                .mg-title {
                    @include title;
                }
            }
        }
        @include media-800 {
            .rencent-sold {
                .mg-title {
                    @include mTitle;
                }
            }
        }
    }
    .explore-listing {
        @include pd;
        @include media-min-800 {
            .template4-listing-market-insight {
                .mg-title {
                    @include title;
                    text-align: left;
                }
            }
        }
    }
    .explore-nbr-wrap {
        @include pd;
        @include media-min-800 {
            .template4-listing-market-insight {
                .mg-title {
                    @include title;
                    text-align: left;
                }
            }
        }
    }
    .search-seo-insight {
        .md-search-seo {
            .search-seo {
                .group {
                    .title.in-map-list {
                        color: #4a4a60;
                    }
                    .content .item .anchor.in-map-list {
                        color: #4a4a60;
                        &:hover {
                            color: #4c84ff;
                        }
                    }
                }
                .action.in-map-list {
                    color: #4c84ff;
                    .icon .iconfont.in-map-list {
                        color: #4c84ff;
                    }
                }
            }
        }
    }
    .quick-search {
        @include pd;
        .md-quick-search.inner {
            @include media-min-800 {
                .mg-title {
                    @include title;
                    text-align: left;
                }
            }
        }
    }
}
</style>
